import { render, staticRenderFns } from "./AuthFooter.vue?vue&type=template&id=9770da2c&scoped=true&"
import script from "./AuthFooter.vue?vue&type=script&lang=js&"
export * from "./AuthFooter.vue?vue&type=script&lang=js&"
import style0 from "./AuthFooter.vue?vue&type=style&index=0&id=9770da2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9770da2c",
  null
  
)

export default component.exports